import { Checkbox, Td, Th } from '@chakra-ui/react'

import { IRowSelection } from './useRowSelection'

/** Altura do checkbox de seleção, uma só. Havia `sm` em duas telas e `md` na terceira. */
const SELECT_CHECKBOX_SIZE = 'sm'

/**
 * Largura da coluna de seleção. Ela guarda um controle de largura fixa e nada mais — sem isso a
 * tabela reparte a sobra com ela e a coluna do lado encolhe.
 */
const SELECT_COLUMN_WIDTH = '36px'

export interface ISelectAllCheckboxProps {
  selection: IRowSelection
}

/**
 * O cabeçalho da coluna de seleção — **o `<Th>` inteiro**, não só o checkbox: a geometria da
 * coluna é parte do que este eixo unifica. Havia três receitas para ela
 * (`verticalAlign="middle" textAlign="center"` em duas telas, `w="36px"` na terceira), e a
 * coluna ficava com largura diferente em cada listagem.
 */
export function SelectAllCheckbox({ selection }: ISelectAllCheckboxProps) {
  return (
    <Th w={SELECT_COLUMN_WIDTH} textAlign="center" verticalAlign="middle">
      <Checkbox
        size={SELECT_CHECKBOX_SIZE}
        aria-label="Marcar todos"
        isChecked={selection.isAllSelected}
        isIndeterminate={selection.isIndeterminate}
        isDisabled={selection.isEmpty}
        onChange={selection.toggleAll}
      />
    </Th>
  )
}

export interface ISelectRowCheckboxProps {
  selection: IRowSelection
  /** O id da linha — o mesmo que o `getId` do hook devolve. */
  id: number
  /** Linha que não pode ser marcada (um inscrito não pago). Combina com o `isSelectable` do hook. */
  isDisabled?: boolean
}

/** A célula de seleção de uma linha — o `<Td>` e o checkbox, pelo mesmo motivo do `<Th>` acima. */
export function SelectRowCheckbox({ selection, id, isDisabled }: ISelectRowCheckboxProps) {
  return (
    <Td textAlign="center" verticalAlign="middle">
      <Checkbox
        size={SELECT_CHECKBOX_SIZE}
        aria-label="Marcar registro"
        isChecked={selection.isSelected(id)}
        isDisabled={isDisabled}
        onChange={() => selection.toggle(id)}
      />
    </Td>
  )
}
